import type { OperationKind, PlaceEvent, SpecialEvent, StayOperation } from '../domain/scales'
import { type EventRow, NO_EVENT_DETAILS } from './types'

export type ShownEvent = EventRow & {
  fromSostrat: boolean
  stayId: string | null
  outsideStay: StayWindow | null
}

export interface StayWindow {
  start: string
  end: string | null
}

const outsideStay = (start: string, end: string, stay: StayWindow): StayWindow | null => {
  const startsBefore = Date.parse(start) < Date.parse(stay.start)
  const endsAfter = stay.end !== null && Date.parse(end) > Date.parse(stay.end)
  return startsBefore || endsAfter ? stay : null
}

type QualifyingOperation = StayOperation & {
  kind: OperationKind
  goods: string
  quantityT: number
  windowStart: string
  windowEnd: string
}

const qualifies = (operation: StayOperation): operation is QualifyingOperation =>
  operation.state !== 'Anulado' &&
  operation.kind !== null &&
  operation.goods !== null &&
  operation.quantityT !== null &&
  operation.windowStart !== null &&
  operation.windowEnd !== null

export const sostratBombeoId = (stayId: string, index: number): string => `sostrat:${stayId}:${String(index)}`

export const sostratBombeos = (events: readonly EventRow[]): ShownEvent[] =>
  events
    .filter((event): event is EventRow & PlaceEvent => event.type === 'PLACE')
    .flatMap(stay =>
      stay.operations.flatMap((operation, index) => {
        if (!qualifies(operation)) return []
        const bombeo: EventRow & SpecialEvent = {
          ...NO_EVENT_DETAILS,
          id: sostratBombeoId(stay.id, index),
          scaleId: stay.scaleId,
          year: stay.year,
          type: 'BOMBEO',
          startTime: operation.windowStart,
          endTime: operation.windowEnd,
          terminals: [],
          productClass: operation.productClass,
          product: operation.goods,
          quantityT: operation.quantityT,
          operationKind: operation.kind,
        }
        const stayWindow = { start: stay.startTime, end: stay.endTime }
        return [
          {
            ...bombeo,
            fromSostrat: true,
            stayId: stay.id,
            outsideStay: outsideStay(operation.windowStart, operation.windowEnd, stayWindow),
          },
        ]
      }),
    )

export const shownEvents = (events: readonly EventRow[]): ShownEvent[] => [
  ...events.map(event => ({ ...event, fromSostrat: false, stayId: null, outsideStay: null })),
  ...sostratBombeos(events),
]
